"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopPromiseCaughtError = exports.loopPromiseCaughtError = function loopPromiseCaughtError(originalActionType, error) {
  return "\nException thrown when running Cmds from action: " + originalActionType + ".\n\nThrown exception: \n" + error + "\n";
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-loop/lib/errors.js
// module id = 248
// module chunks = 0